export enum InputTypes {
  TEXT = 'text',
}
